/**
 * The weekly 40-hour rule (D-007) — the parts both the server and the browser
 * need. The rule itself (start week, counting, refusals) lives on the server in
 * `packages/backend/src/domain/weekly-hours.ts`; the browser only renders what
 * the server sends in `TimesheetTotals.weeklyTarget`.
 */
/**
 * The $0.00 task code that fills a week to 40 hours. It means time NOT worked
 * (Jeff, 2026-10-18), may be charged only to an unrestricted fund, and is left
 * out of an hourly employee's payroll split in financial-system. Reference it
 * through this constant only; never write the literal code elsewhere.
 */
export const FILLER_TASK_CODE = 'A1';
/** Exactly this many minutes (40 hours) to submit a covered week. */
export const REQUIRED_WEEKLY_MINUTES = 2400;
/**
 * Minutes as an hours figure for people to read: 2400 -> "40", 390 -> "6.5",
 * 15 -> "0.25". Whole minutes in, at most two decimals out, no trailing zeros.
 * Server messages and the screen use this one function so they never disagree.
 */
export function formatHoursFromMinutes(minutes) {
    const hours = Math.round((minutes / 60) * 100) / 100;
    return String(hours);
}
//# sourceMappingURL=weekly.js.map